import React from "react";
import NotificaionsFormCheckbox from './NotificaionsFormCheckbox';

export default (props) => {

    const {
        formEdit,
        is_notification_push_new_order,
        is_notification_push_change_order,
        is_notification_push_new_message,
        is_notification_email_new_order,
        is_notification_email_change_order,
        is_notification_email_new_message,
        is_notification_sms_new_order,
        is_notification_sms_change_order,
        is_notification_sms_new_message,

        handleOnChange,
        onSubmit,
        onEdit,
    } = props;
        
    return (
            <div className="white-block-content">

                <ul className="data-with-labels">
                    <li>
                        <NotificaionsFormCheckbox
                            handleOnChange={handleOnChange}
                            fieldName="is_notification_push_new_order"
                            value={is_notification_push_new_order}
                            label="Push-уведомление о подходящем по месту новом заказе"
                            formEdit={formEdit}
                            />
                    </li>
                    <li>
                        <NotificaionsFormCheckbox
                            handleOnChange={handleOnChange}
                            fieldName="is_notification_push_change_order"
                            value={is_notification_push_change_order}
                            label="PUSH-уведомление об изменение заказа"
                            formEdit={formEdit}
                            />
                    </li>
                    <li>
                        <NotificaionsFormCheckbox
                            handleOnChange={handleOnChange}
                            fieldName="is_notification_push_new_message"
                            value={is_notification_push_new_message}
                            label="PUSH-уведомление о новом сообщении"
                            formEdit={formEdit}
                            />
                    </li>
                    <li>
                        <NotificaionsFormCheckbox
                            handleOnChange={handleOnChange}
                            fieldName="is_notification_email_new_order"
                            value={is_notification_email_new_order}
                            label="Уведомления по электронной почте о новом заказе"
                            formEdit={formEdit}
                            />
                    </li>
                    <li>
                        <NotificaionsFormCheckbox
                            handleOnChange={handleOnChange}
                            fieldName="is_notification_email_change_order"
                            value={is_notification_email_change_order}
                            label="Уведомления по электронной почте об изменении заказа"
                            formEdit={formEdit}
                            />
                    </li>
                    <li>
                        <NotificaionsFormCheckbox
                            handleOnChange={handleOnChange}
                            fieldName="is_notification_email_new_message"
                            value={is_notification_email_new_message}
                            label="Уведомления по электронной почте о новом сообщении"
                            formEdit={formEdit}
                            />
                    </li>
                    <li>
                        <NotificaionsFormCheckbox
                            handleOnChange={handleOnChange}
                            fieldName="is_notification_sms_new_order"
                            value={is_notification_sms_new_order}
                            label="СМС-уведомления о новом заказе"
                            formEdit={formEdit}
                            />
                    </li>
                    <li>
                        <NotificaionsFormCheckbox
                            handleOnChange={handleOnChange}
                            fieldName="is_notification_sms_change_order"
                            value={is_notification_sms_change_order}
                            label="СМС-уведомления об изменении заказа"
                            formEdit={formEdit}
                            />
                    </li>
                    <li>
                        <NotificaionsFormCheckbox
                            handleOnChange={handleOnChange}
                            fieldName="is_notification_sms_new_message"
                            value={is_notification_sms_new_message}
                            label="СМС-уведомления о новом сообщении"
                            formEdit={formEdit}
                            />
                    </li>
                </ul>
                <div className="actions">
                    <div className="big-button empty-button">
                        <button onClick={() => onEdit()}>
                            {formEdit ? 'Отмена' : 'Редактировать'}
                        </button>
                    </div>
                    
                    {
                        formEdit
                        ?                         
                        <div className="big-button">
                            <button onClick={() => onSubmit()}>Сохранить</button>
                        </div>
                        : null
                    }

                </div>
            </div>
    )
}


// WEBPACK FOOTER //
// ./src/components/Account/NotificaionsForm.js